import { useCallback, useEffect } from "react";
import { useBoolean } from "@chakra-ui/react";

const COOKIEBOT_DIALOG_ID = "CybotCookiebotDialog";
const COOKIEBOT_UNDERLAY_ID = "CybotCookiebotDialogBodyUnderlay";
const COOKIEBOT_LOADED_CHECK_TIMEOUT = 4000;

const hideCookieBotConsentUnderlay = () => {
    const underlay = document.getElementById(COOKIEBOT_UNDERLAY_ID);
    if (underlay) {
        underlay.style.display = "none";
    }
};

const isConsentDialogOnScreen = (): boolean => Boolean(document.getElementById(COOKIEBOT_DIALOG_ID));

export function useCookieBotConsentReady() {
    const [isConsentReady, setIsConsentReady] = useBoolean(false);
    const handleCookieBotConsentReady = useCallback(() => {
        setIsConsentReady.on();
        hideCookieBotConsentUnderlay();
    }, [setIsConsentReady]);

    useEffect(() => {
        if (window.Cookiebot?.hasResponse) {
            handleCookieBotConsentReady();
            return;
        }

        const loadedCheckTimeout = setTimeout(() => {
            if (!isConsentDialogOnScreen()) {
                handleCookieBotConsentReady();
            }
        }, COOKIEBOT_LOADED_CHECK_TIMEOUT);

        window.addEventListener("CookiebotOnConsentReady", handleCookieBotConsentReady, false);

        return () => {
            clearTimeout(loadedCheckTimeout);
            window.removeEventListener("CookiebotOnConsentReady", handleCookieBotConsentReady);
        };
    }, [handleCookieBotConsentReady]);

    return isConsentReady;
}
